module.exports = __webpack_public_path__ + "img/machine.32eae90.jpg";